import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SinglePurchasePriceCaption = ({ price , isCentAmount  })=>{
    const { currency  } = useIntl();
    return /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, ' ', /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        centAmount: isCentAmount
    }));
};

export { SinglePurchasePriceCaption };
//# sourceMappingURL=SinglePurchasePriceCaption.js.map
